import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    if (this.props.onRetry) this.props.onRetry();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: 400, padding: 40,
          textAlign: 'center',
        }}>
          <span style={{ fontSize: 48, marginBottom: 16 }}>⚠️</span>
          <h2 style={{
            color: 'var(--text-primary)', fontSize: 20,
            fontWeight: 700, margin: '0 0 8px',
          }}>
            Something went wrong
          </h2>
          <p style={{
            color: 'var(--text-secondary)', fontSize: 14,
            margin: '0 0 24px', maxWidth: 400, lineHeight: 1.6,
          }}>
            {this.props.message || 'An unexpected error occurred while loading this section.'}
          </p>
          <div style={{ display: 'flex', gap: 10 }}>
            <button
              onClick={this.handleRetry}
              className="auth-button auth-button-primary"
              style={{ padding: '10px 24px', fontSize: 14 }}
            >
              Try Again
            </button>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '10px 24px', fontSize: 14, borderRadius: 10,
                border: '1px solid var(--border-primary)',
                background: 'transparent', color: 'var(--text-secondary)',
                cursor: 'pointer', fontFamily: 'inherit',
              }}
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
